// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/AkayaTelivigala-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/fonts/AkayaTelivigala-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --color-pri: #dfdfeb4f;
    --color-sec: #b8afaf;
    --color-tri: #3a3939;
    --color-qua: #b18ec9;
    --color-valid1: #679464;
    --color-valid2: #9bca98;
    --color-invalid1: #b13838;
    --color-invalid2: #e27070;
    --filter-color-valid1: invert(57%) sepia(8%) saturate(1560%) hue-rotate(68deg) brightness(92%) contrast(91%);
    --filter-color-valid2: invert(85%) sepia(23%) saturate(426%) hue-rotate(68deg) brightness(88%) contrast(86%);
    --filter-color-invalid1: invert(27%) sepia(12%) saturate(5679%) hue-rotate(325deg) brightness(107%) contrast(94%);
    --filter-color-invalid2: invert(54%) sepia(68%) saturate(563%) hue-rotate(312deg) brightness(95%) contrast(87%);
    --filter-color-pri: invert(75%) sepia(91%) saturate(3%) hue-rotate(314deg) brightness(101%) contrast(90%);
    --filter-color-sec: invert(72%) sepia(4%) saturate(324%) hue-rotate(314deg) brightness(99%) contrast(88%);
    --filter-color-tri: invert(18%) sepia(9%) saturate(42%) hue-rotate(314deg) brightness(92%) contrast(84%);
    --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);
    --radius-pri: 10px;
    --weight-pri: 900;
    --weight-sec: 700;
    --weight-tri: 500;
    font-family:
        "Akaya Telivigala",
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto,
        Oxygen,
        Ubuntu,
        Cantarell,
        "Open Sans",
        "Helvetica Neue",
        sans-serif;
    letter-spacing: 0.1em;
    line-height: 1.3em;
    interpolate-size: allow-keywords;
}

button {
    background-color: transparent;
    border: none;
}

button:hover {
    cursor: pointer;
}

.container {
    width: 70%;
    margin: auto;
    height: 100vh;
    display: grid;
    grid-template-columns: max-content 3fr 10fr;
    grid-template-rows: 7vh max-content 8fr;
    row-gap: calc(2 * var(--size-pri));
}

header {
    grid-area: 1 / 1 / 2 / 4;
    grid-template-columns: subgrid;
    display: grid;
    padding: var(--size-pri);
    background-color: var(--color-pri);
    align-items: center;
    align-content: center;
}

.user-header {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    font-size: calc(1.5 * var(--size-pri));
    font-weight: var(--weight-pri);
    z-index: 1;

    img {
        height: 70%;
        aspect-ratio: 1 / 1;
        justify-self: right;
    }

    img:hover {
        cursor: pointer;
    }

    #user {
        color: black;
        justify-self: left;
        scale: 1;
        max-width: 15ch;
        font-weight: var(--weight-pri);
    }
}

.user-header,
.project-content,
.nav-content,
.category-content,
.subcategory-content {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    column-gap: var(--size-pri);
}

.timer-menu,
.timer-content,
.project-content,
.nav-content,
.category-content,
.subcategory-content {
    img {
        aspect-ratio: 1 / 1;
        justify-self: right;
    }

    img:hover {
        cursor: pointer;
    }

    button {
        color: var(--color-tri);
        justify-self: left;
        transition: transform 0.3s ease-in-out;
    }

    button:hover {
        transform: scale(1.1);
    }
}

.menu-header {
    width: 80%;
    display: flex;
    gap: calc(2 * var(--size-pri));
    justify-content: right;
    padding: calc(2 * var(--size-pri));
    margin: auto;

    button {
        display: flex;
        position: relative;
        background-color: var(--color-qua);
        color: white;
        font-weight: var(--weight-sec);
        padding: 0.5em 1em;
        border-radius: var(--radius-pri);
        transition:
            background-color 1s,
            color 1s;
    }

    button:after,
    button:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        height: 100%;
        width: 100%;
        /* top: -1em;
        left: -10%; */
        /* margin-top: 10px; */
        opacity: 0;
        transition:
            opacity 1s,
            transform 1s;
    }

    button:before {
        border-left: 3px solid var(--color-tri);
        border-right: 3px solid var(--color-tri);
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
    }

    button:after {
        border-bottom: 3px solid var(--color-tri);
        border-top: 3px solid var(--color-tri);
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
    }

    button:hover:after,
    button:hover:before {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
        border-radius: var(--radius-pri);
    }

    /* button:hover {
        /* box-shadow: 0 0.6em 0.5em -0.5em var(--color-tri); */
    /* background-color: var(--color-pri);
    color: var(--color-tri) */
    /* } */

    img {
        display: none;
        min-height: 3vh;
        min-width: 3vh;
        aspect-ratio: 1 / 1;
        filter: invert(99%) sepia(0%) saturate(7500%) hue-rotate(154deg) brightness(113%) contrast(100%);
    }
}

dialog {
    /* padding: calc(4 * var(--size-pri)) 0; */
    width: 100vw;
    max-width: 100%;
    max-height: 80vh;
    margin-top: calc(2 * var(--size-pri));
    overflow: auto;
    scrollbar-width: none;
    border: none;
    background-color: transparent;
    color: var(--color-tri);

    form {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        margin: auto;

        > * {
            max-width: 50ch;
            width: 90%;
            margin: calc(0.5 * var(--size-pri)) auto;
        }
    }

    .form-input {
        label {
            margin-bottom: 20px;
            font-weight: var(--weight-pri);
        }

        input,
        textarea,
        select {
            text-align: center;
            font-weight: var(--weight-tri);
            color: inherit;
            width: 100%;
            height: calc(2 * var(--size-pri));
            border-radius: calc(0.5 * var(--radius-pri));
            margin-top: calc(0.5 * var(--size-pri));
            resize: vertical;
            white-space: pre-line;
        }

        textarea {
            padding-top: calc(0.7 * var(--size-pri));
            height: calc(6 * var(--size-pri));
        }

        input:focus {
            outline: 4px solid var(--color-qua);
            border: none;
        }
    }

    .form-interaction {
        margin-top: var(--size-pri);
        display: flex;
        gap: var(--size-pri);

        * {
            flex: 1;
            display: block;
            height: calc(3 * var(--size-pri));
        }

        #dialog-close {
            background-color: transparent;
            color: inherit;
        }
    }
}

dialog::backdrop {
    backdrop-filter: blur(10px);
}

nav {
    grid-area: 1 / 1 / -1 / 3;
    background-color: var(--color-pri);
    display: grid;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;

    button {
        text-align: left;
    }
}

.timer-content {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: subgrid;
    grid-template-rows: repeat(3, 1fr);
    grid-auto-rows: 1fr;
    align-items: center;
    column-gap: var(--size-pri);
    padding-bottom: calc(3 * var(--size-pri));

    button {
        font-weight: var(--weight-sec);
    }
}

.timer-menu {
    display: grid;
    grid-area: 1 / 1 /-1 /-1;
    grid-template-columns: subgrid;
    grid-auto-rows: max-content;
    place-items: center;
    row-gap: calc(2 * var(--size-pri));
}

.timer-content,
.nav-content,
main {
    grid-auto-rows: 2em;
    font-size: calc(1.3 * var(--size-pri));
}

.timer-content,
.nav-content,
main {
    padding: calc(2 * var(--size-pri));
}

.nav-content {
    grid-row: 3 / span1;
    grid-auto-rows: max-content;
    row-gap: calc(2 * var(--size-pri));
}

.project-content,
.timer-menu {
    box-shadow: 0.6em 0.6em 0.6em -0.6em var(--color-tri);
    border-radius: var(--radius-pri);
    padding-bottom: var(--size-pri);
}

.project-content :has(.category-content-checked) {
    box-shadow: 0.6em 0.6em 0.6em -0.6em var(--color-valid1);
}

.project-content,
.category-content,
.subcategory-content {
    display: grid;
    grid-template-columns: subgrid;
    row-gap: calc(0.5 * var(--size-pri));
}

.category-content-checked,
.subcategory-content-checked {
    color: var(--color-valid1);
}

.category-content > button:nth-child(2) {
    font-weight: var(--weight-sec);
}

.subcategory-content {
    button {
        font-size: 0.8em;
        font-weight: var(--weight-tri);
    }

    img {
        height: 80%;
    }
}

main {
    grid-row: span 2;
    display: flex;
    flex-direction: column;
    gap: calc(2 * var(--size-pri));
    align-items: center;
}

.initial-main {
    padding: 0 5vw;

    > * {
        margin-bottom: 1em;
    }

    p {
        line-height: 1.4em;
    }

    button {
        display: flex;
        position: relative;
        background-color: var(--color-qua);
        color: white;
        font-weight: var(--weight-sec);
        padding: 0.5em 1em;
        border-radius: var(--radius-pri);
        transition:
            background-color 1s,
            color 1s;
    }

    button:after,
    button:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        height: 100%;
        width: 100%;
        /* top: -1em;
        left: -10%; */
        /* margin-top: 10px; */
        opacity: 0;
        transition:
            opacity 1s,
            transform 1s;
    }

    button:before {
        border-left: 3px solid var(--color-tri);
        border-right: 3px solid var(--color-tri);
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
    }

    button:after {
        border-bottom: 3px solid var(--color-tri);
        border-top: 3px solid var(--color-tri);
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
    }

    button:hover:after,
    button:hover:before {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
        border-radius: var(--radius-pri);
    }

    input {
        font-weight: var(--weight-tri);
        color: inherit;
        width: min(30ch, 90%);
        height: calc(2 * var(--size-pri));
        border-radius: calc(0.5 * var(--radius-pri));
        padding-left: 0.2em;
    }

    input:focus {
        outline: 4px solid var(--color-qua);
        border: none;
    }
}

.category-card,
.initial-main {
    position: relative;
    width: 80%;
    margin-bottom: calc(2 * var(--size-pri));
    box-shadow: 0.1em 0.6em 0.6em -0.6em var(--color-tri);
    transition: box-shadow 0.5s ease-in-out;
    border-radius: var(--size-pri) var(--size-pri) 0 0;
}

.category-card:hover {
    box-shadow:
        0.3em 0.6em 0.6em -0.6em var(--color-tri),
        -0.3em -0.3em 0.6em -0.6em var(--color-tri);
}

.category-card-checked {
    box-shadow: 0.1em 0.6em 0.6em -0.6em var(--color-valid1);
}

.category-card-checked:hover {
    box-shadow:
        0.3em 0.6em 0.6em -0.6em var(--color-valid1),
        -0.3em -0.3em 0.6em -0.6em var(--color-valid1);
}

details {
    padding: 0 var(--size-pri);
    color: var(--color-tri);
    border-radius: var(--radius-pri);
    overflow: hidden;
    position: relative;

    > * {
        padding-left: var(--size-pri);
        margin: calc(0.5 * var(--size-pri));
    }

    summary {
        font-size: calc(1.5 * var(--size-pri));
        font-weight: var(--weight-sec);
    }

    summary:hover {
        cursor: pointer;
    }

    summary:first-of-type {
        list-style-type: none;
    }

    p {
        padding-block: 1rem;
        text-align: justify;
        text-wrap: pretty;
        max-width: 70ch;
        white-space: pre-line;
    }

    p input {
        text-align: center;
        position: relative;
        inset: 0.1em 1em;
        margin-right: 2em;
        width: 1em;
        aspect-ratio: 1 / 1;
        appearance: none;
        border-radius: 10%;
        border: 1px solid var(--color-invalid1);
        box-shadow: none;
        font-size: 1em;
    }

    p input:checked {
        background-color: #679464;
        border: none;

        + label {
            filter: blur(0.1em);
            color: var(--color-valid2);
        }
    }

    .list-display {
        display: grid;
        grid-template-columns: 1fr 10fr;
        grid-auto-rows: fit-content;
        gap: calc(0.8 * var(--size-pri));
    }

    .date {
        position: absolute;
        top: 0;
        right: 0;
        border-radius: var(--radius-pri);
        background-color: var(--color-pri);
        font-size: 0.7em;
        padding: 0.2em;
        z-index: 10;
    }
}

details::details-content {
    font-size: 1rem;
    block-size: 0;
    transition:
        block-size 1s,
        content-visibility 1s;
    transition-behavior: allow-discrete;
}

details:open::details-content {
    block-size: auto;
}

.category-interactions {
    text-align: right;
    margin-bottom: 0;
    display: flex;
    justify-content: right;
}

.category-interactions button {
    padding: 0.5em 1em;
    margin-left: var(--size-pri);
    border-radius: var(--size-pri) var(--size-pri) 0 0;
    background-color: var(--color-pri);
    font-weight: var(--weight-sec);
    display: flex;
    justify-content: center;
}

#edit-btn img {
    filter: var(--filter-color-valid1);
}

#edit-btn:hover {
    background-color: var(--color-valid2);

    img {
        filter: var(--filter-color-pri);
    }
}

#delete-btn img {
    filter: var(--filter-color-invalid1);
}

#delete-btn:hover {
    background-color: var(--color-invalid2);

    img {
        filter: var(--filter-color-pri);
    }
}

@font-face {
    font-family: "Akaya";
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@keyframes fadeIn {
    0% {
        transition:
            block-size 1s,
            content-visibility 1s;
        transition-behavior: allow-discrete;
        opacity: 0;
        block-size: 0;
        content-visibility: hidden;
    }

    100% {
        opacity: 1;
        block-size: auto;
        content-visibility: visible;
    }
}

@media (max-width: 1200px) {
    .container {
        width: 100%;
    }
}

@media (max-width: 800px) {
    /* .user-header {
        padding: auto 1em;
        margin: auto;
    } */

    header {
        gap: var(--size-pri);
    }

    .user-header img {
        min-height: 5vh;
        max-width: 5vh;
        min-width: 5vh;
        aspect-ratio: 1 / 1;
    }

    .user-header,
    nav {
        button {
            display: none;
        }
    }

    .menu-header {
        gap: var(--size-pri);
        padding: var(--size-pri) 0 var(--size-pri) var(--size-pri);
        margin-left: 0;
        justify-content: left;

        span {
            display: none;
        }

        img {
            display: block;
        }
    }

    .timer-content,
    .nav-content,
    .timer-menu {
        padding-left: 0;
        padding-right: 0;
    }

    .user-header,
    .timer-menu,
    .project-content,
    .category-content,
    .subcategory-content {
        min-width: 20vw;
        grid-template-columns: 1fr;
        justify-items: center;
        justify-content: center;
        justify-self: center;

        > * {
            margin: auto;
        }
    }

    main {
        padding: calc(2 * var(--size-pri)) calc(0.5 * var(--size-pri));
    }

    .category-card {
        width: 100%;
    }

    details {
        .list-display {
            padding-left: 0;
            padding-right: 0;
        }

        summary {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: calc(0.5 * var(--size-pri));
        }

        .date {
            position: relative;
        }
    }

    .category-interactions {
        justify-content: left;
        padding: 0;
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/main-style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,4GAA4G;IAC5G,4GAA4G;IAC5G,iHAAiH;IACjH,+GAA+G;IAC/G,yGAAyG;IACzG,yGAAyG;IACzG,wGAAwG;IACxG,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB;;;;;;;;;;;;kBAYc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,aAAa;IACb,2CAA2C;IAC3C,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,aAAa;IACb,wBAAwB;IACxB,kCAAkC;IAClC,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sCAAsC;IACtC,8BAA8B;IAC9B,UAAU;;IAEV;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,eAAe;QACf,8BAA8B;IAClC;AACJ;;AAEA;;;;;IAKI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;;;;;IAMI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,sCAAsC;IAC1C;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,kCAAkC;IAClC,YAAY;;IAEZ;QACI,aAAa;QACb,kBAAkB;QAClB,kCAAkC;QAClC,YAAY;QACZ,8BAA8B;QAC9B,kBAAkB;QAClB,gCAAgC;QAChC;;oBAEY;IAChB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,qBAAqB;QACrB,YAAY;QACZ,WAAW;QACX;qBACa;QACb,sBAAsB;QACtB,UAAU;QACV;;wBAEgB;IACpB;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;QACtC,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;;QAEI,UAAU;QACV,2BAA2B;QAC3B,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;+DAC2D;IAC3D;6BACyB;IACzB,MAAM;;IAEN;QACI,aAAa;QACb,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gGAAgG;IACpG;AACJ;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;;IAEvB;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,qBAAqB;QACrB,YAAY;;QAEZ;YACI,eAAe;YACf,UAAU;YACV,wCAAwC;QAC5C;IACJ;;IAEA;QACI;YACI,mBAAmB;YACnB,8BAA8B;QAClC;;QAEA;;;YAGI,kBAAkB;YAClB,8BAA8B;YAC9B,cAAc;YACd,WAAW;YACX,iCAAiC;YACjC,4CAA4C;YAC5C,uCAAuC;YACvC,gBAAgB;YAChB,qBAAqB;QACzB;;QAEA;YACI,wCAAwC;YACxC,iCAAiC;QACrC;;QAEA;YACI,mCAAmC;YACnC,YAAY;QAChB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,aAAa;QACb,oBAAoB;;QAEpB;YACI,OAAO;YACP,cAAc;YACd,iCAAiC;QACrC;;QAEA;YACI,6BAA6B;YAC7B,cAAc;QAClB;IACJ;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;;IAE3B;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,yCAAyC;;IAEzC;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;;;IAGI,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;;;IAGI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;;IAEI,qDAAqD;IACrD,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;;IAEd;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,kCAAkC;QAClC,YAAY;QACZ,8BAA8B;QAC9B,kBAAkB;QAClB,gCAAgC;QAChC;;oBAEY;IAChB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,qBAAqB;QACrB,YAAY;QACZ,WAAW;QACX;qBACa;QACb,sBAAsB;QACtB,UAAU;QACV;;wBAEgB;IACpB;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;QACtC,8BAA8B;QAC9B,sBAAsB;IAC1B;;IAEA;;QAEI,UAAU;QACV,2BAA2B;QAC3B,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;QAC9B,cAAc;QACd,qBAAqB;QACrB,iCAAiC;QACjC,4CAA4C;QAC5C,mBAAmB;IACvB;;IAEA;QACI,mCAAmC;QACnC,YAAY;IAChB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,qDAAqD;IACrD,uCAAuC;IACvC,kDAAkD;AACtD;;AAEA;IACI;;mDAE+C;AACnD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI;;sDAEkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;;IAElB;QACI,6BAA6B;QAC7B,mCAAmC;IACvC;;IAEA;QACI,sCAAsC;QACtC,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,uCAAuC;QACvC,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,YAAY;;QAEZ;YACI,mBAAmB;YACnB,0BAA0B;QAC9B;IACJ;;IAEA;QACI,aAAa;QACb,+BAA+B;QAC/B,2BAA2B;QAC3B,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,kCAAkC;QAClC,gBAAgB;QAChB,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;;6BAEyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kDAAkD;IAClD,kCAAkC;IAClC,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;;IAErC;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;;IAEvC;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,oBAAoB;IACpB;;8DAEiE;IACjE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI;;iCAEyB;QACzB,mCAAmC;QACnC,UAAU;QACV,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;;;OAGG;;IAEH;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,cAAc;QACd,mBAAmB;IACvB;;IAEA;;QAEI;YACI,aAAa;QACjB;IACJ;;IAEA;QACI,oBAAoB;QACpB,0DAA0D;QAC1D,cAAc;QACd,qBAAqB;;QAErB;YACI,aAAa;QACjB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;;;QAGI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;;;;QAKI,eAAe;QACf,0BAA0B;QAC1B,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;;QAEpB;YACI,YAAY;QAChB;IACJ;;IAEA;QACI,8DAA8D;IAClE;;IAEA;QACI,WAAW;IACf;;IAEA;QACI;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,gCAAgC;QACpC;;QAEA;YACI,kBAAkB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,SAAS;IACb;AACJ","sourcesContent":[":root {\n    --color-pri: #dfdfeb4f;\n    --color-sec: #b8afaf;\n    --color-tri: #3a3939;\n    --color-qua: #b18ec9;\n    --color-valid1: #679464;\n    --color-valid2: #9bca98;\n    --color-invalid1: #b13838;\n    --color-invalid2: #e27070;\n    --filter-color-valid1: invert(57%) sepia(8%) saturate(1560%) hue-rotate(68deg) brightness(92%) contrast(91%);\n    --filter-color-valid2: invert(85%) sepia(23%) saturate(426%) hue-rotate(68deg) brightness(88%) contrast(86%);\n    --filter-color-invalid1: invert(27%) sepia(12%) saturate(5679%) hue-rotate(325deg) brightness(107%) contrast(94%);\n    --filter-color-invalid2: invert(54%) sepia(68%) saturate(563%) hue-rotate(312deg) brightness(95%) contrast(87%);\n    --filter-color-pri: invert(75%) sepia(91%) saturate(3%) hue-rotate(314deg) brightness(101%) contrast(90%);\n    --filter-color-sec: invert(72%) sepia(4%) saturate(324%) hue-rotate(314deg) brightness(99%) contrast(88%);\n    --filter-color-tri: invert(18%) sepia(9%) saturate(42%) hue-rotate(314deg) brightness(92%) contrast(84%);\n    --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);\n    --radius-pri: 10px;\n    --weight-pri: 900;\n    --weight-sec: 700;\n    --weight-tri: 500;\n    font-family:\n        \"Akaya Telivigala\",\n        system-ui,\n        -apple-system,\n        BlinkMacSystemFont,\n        \"Segoe UI\",\n        Roboto,\n        Oxygen,\n        Ubuntu,\n        Cantarell,\n        \"Open Sans\",\n        \"Helvetica Neue\",\n        sans-serif;\n    letter-spacing: 0.1em;\n    line-height: 1.3em;\n    interpolate-size: allow-keywords;\n}\n\nbutton {\n    background-color: transparent;\n    border: none;\n}\n\nbutton:hover {\n    cursor: pointer;\n}\n\n.container {\n    width: 70%;\n    margin: auto;\n    height: 100vh;\n    display: grid;\n    grid-template-columns: max-content 3fr 10fr;\n    grid-template-rows: 7vh max-content 8fr;\n    row-gap: calc(2 * var(--size-pri));\n}\n\nheader {\n    grid-area: 1 / 1 / 2 / 4;\n    grid-template-columns: subgrid;\n    display: grid;\n    padding: var(--size-pri);\n    background-color: var(--color-pri);\n    align-items: center;\n    align-content: center;\n}\n\n.user-header {\n    grid-column: 1 / 3;\n    display: grid;\n    grid-template-columns: subgrid;\n    align-items: center;\n    font-size: calc(1.5 * var(--size-pri));\n    font-weight: var(--weight-pri);\n    z-index: 1;\n\n    img {\n        height: 70%;\n        aspect-ratio: 1 / 1;\n        justify-self: right;\n    }\n\n    img:hover {\n        cursor: pointer;\n    }\n\n    #user {\n        color: black;\n        justify-self: left;\n        scale: 1;\n        max-width: 15ch;\n        font-weight: var(--weight-pri);\n    }\n}\n\n.user-header,\n.project-content,\n.nav-content,\n.category-content,\n.subcategory-content {\n    grid-column: 1 / 3;\n    display: grid;\n    grid-template-columns: subgrid;\n    align-items: center;\n    column-gap: var(--size-pri);\n}\n\n.timer-menu,\n.timer-content,\n.project-content,\n.nav-content,\n.category-content,\n.subcategory-content {\n    img {\n        aspect-ratio: 1 / 1;\n        justify-self: right;\n    }\n\n    img:hover {\n        cursor: pointer;\n    }\n\n    button {\n        color: var(--color-tri);\n        justify-self: left;\n        transition: transform 0.3s ease-in-out;\n    }\n\n    button:hover {\n        transform: scale(1.1);\n    }\n}\n\n.menu-header {\n    width: 80%;\n    display: flex;\n    gap: calc(2 * var(--size-pri));\n    justify-content: right;\n    padding: calc(2 * var(--size-pri));\n    margin: auto;\n\n    button {\n        display: flex;\n        position: relative;\n        background-color: var(--color-qua);\n        color: white;\n        font-weight: var(--weight-sec);\n        padding: 0.5em 1em;\n        border-radius: var(--radius-pri);\n        transition:\n            background-color 1s,\n            color 1s;\n    }\n\n    button:after,\n    button:before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        display: inline-block;\n        height: 100%;\n        width: 100%;\n        /* top: -1em;\n        left: -10%; */\n        /* margin-top: 10px; */\n        opacity: 0;\n        transition:\n            opacity 1s,\n            transform 1s;\n    }\n\n    button:before {\n        border-left: 3px solid var(--color-tri);\n        border-right: 3px solid var(--color-tri);\n        -webkit-transform: scale(0, 1);\n        transform: scale(0, 1);\n    }\n\n    button:after {\n        border-bottom: 3px solid var(--color-tri);\n        border-top: 3px solid var(--color-tri);\n        -webkit-transform: scale(1, 0);\n        transform: scale(1, 0);\n    }\n\n    button:hover:after,\n    button:hover:before {\n        opacity: 1;\n        -webkit-transform: scale(1);\n        transform: scale(1);\n        border-radius: var(--radius-pri);\n    }\n\n    /* button:hover {\n        /* box-shadow: 0 0.6em 0.5em -0.5em var(--color-tri); */\n    /* background-color: var(--color-pri);\n    color: var(--color-tri) */\n    /* } */\n\n    img {\n        display: none;\n        min-height: 3vh;\n        min-width: 3vh;\n        aspect-ratio: 1 / 1;\n        filter: invert(99%) sepia(0%) saturate(7500%) hue-rotate(154deg) brightness(113%) contrast(100%);\n    }\n}\n\ndialog {\n    /* padding: calc(4 * var(--size-pri)) 0; */\n    width: 100vw;\n    max-width: 100%;\n    max-height: 80vh;\n    margin-top: calc(2 * var(--size-pri));\n    overflow: auto;\n    scrollbar-width: none;\n    border: none;\n    background-color: transparent;\n    color: var(--color-tri);\n\n    form {\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        align-content: center;\n        margin: auto;\n\n        > * {\n            max-width: 50ch;\n            width: 90%;\n            margin: calc(0.5 * var(--size-pri)) auto;\n        }\n    }\n\n    .form-input {\n        label {\n            margin-bottom: 20px;\n            font-weight: var(--weight-pri);\n        }\n\n        input,\n        textarea,\n        select {\n            text-align: center;\n            font-weight: var(--weight-tri);\n            color: inherit;\n            width: 100%;\n            height: calc(2 * var(--size-pri));\n            border-radius: calc(0.5 * var(--radius-pri));\n            margin-top: calc(0.5 * var(--size-pri));\n            resize: vertical;\n            white-space: pre-line;\n        }\n\n        textarea {\n            padding-top: calc(0.7 * var(--size-pri));\n            height: calc(6 * var(--size-pri));\n        }\n\n        input:focus {\n            outline: 4px solid var(--color-qua);\n            border: none;\n        }\n    }\n\n    .form-interaction {\n        margin-top: var(--size-pri);\n        display: flex;\n        gap: var(--size-pri);\n\n        * {\n            flex: 1;\n            display: block;\n            height: calc(3 * var(--size-pri));\n        }\n\n        #dialog-close {\n            background-color: transparent;\n            color: inherit;\n        }\n    }\n}\n\ndialog::backdrop {\n    backdrop-filter: blur(10px);\n}\n\nnav {\n    grid-area: 1 / 1 / -1 / 3;\n    background-color: var(--color-pri);\n    display: grid;\n    grid-template-columns: subgrid;\n    grid-template-rows: subgrid;\n\n    button {\n        text-align: left;\n    }\n}\n\n.timer-content {\n    grid-row: 2 / 3;\n    grid-column: 1 / 3;\n    display: grid;\n    grid-template-columns: subgrid;\n    grid-template-rows: repeat(3, 1fr);\n    grid-auto-rows: 1fr;\n    align-items: center;\n    column-gap: var(--size-pri);\n    padding-bottom: calc(3 * var(--size-pri));\n\n    button {\n        font-weight: var(--weight-sec);\n    }\n}\n\n.timer-menu {\n    display: grid;\n    grid-area: 1 / 1 /-1 /-1;\n    grid-template-columns: subgrid;\n    grid-auto-rows: max-content;\n    place-items: center;\n    row-gap: calc(2 * var(--size-pri));\n}\n\n.timer-content,\n.nav-content,\nmain {\n    grid-auto-rows: 2em;\n    font-size: calc(1.3 * var(--size-pri));\n}\n\n.timer-content,\n.nav-content,\nmain {\n    padding: calc(2 * var(--size-pri));\n}\n\n.nav-content {\n    grid-row: 3 / span1;\n    grid-auto-rows: max-content;\n    row-gap: calc(2 * var(--size-pri));\n}\n\n.project-content,\n.timer-menu {\n    box-shadow: 0.6em 0.6em 0.6em -0.6em var(--color-tri);\n    border-radius: var(--radius-pri);\n    padding-bottom: var(--size-pri);\n}\n\n.project-content :has(.category-content-checked) {\n    box-shadow: 0.6em 0.6em 0.6em -0.6em var(--color-valid1);\n}\n\n.project-content,\n.category-content,\n.subcategory-content {\n    display: grid;\n    grid-template-columns: subgrid;\n    row-gap: calc(0.5 * var(--size-pri));\n}\n\n.category-content-checked,\n.subcategory-content-checked {\n    color: var(--color-valid1);\n}\n\n.category-content > button:nth-child(2) {\n    font-weight: var(--weight-sec);\n}\n\n.subcategory-content {\n    button {\n        font-size: 0.8em;\n        font-weight: var(--weight-tri);\n    }\n\n    img {\n        height: 80%;\n    }\n}\n\nmain {\n    grid-row: span 2;\n    display: flex;\n    flex-direction: column;\n    gap: calc(2 * var(--size-pri));\n    align-items: center;\n}\n\n.initial-main {\n    padding: 0 5vw;\n\n    > * {\n        margin-bottom: 1em;\n    }\n\n    p {\n        line-height: 1.4em;\n    }\n\n    button {\n        display: flex;\n        position: relative;\n        background-color: var(--color-qua);\n        color: white;\n        font-weight: var(--weight-sec);\n        padding: 0.5em 1em;\n        border-radius: var(--radius-pri);\n        transition:\n            background-color 1s,\n            color 1s;\n    }\n\n    button:after,\n    button:before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        display: inline-block;\n        height: 100%;\n        width: 100%;\n        /* top: -1em;\n        left: -10%; */\n        /* margin-top: 10px; */\n        opacity: 0;\n        transition:\n            opacity 1s,\n            transform 1s;\n    }\n\n    button:before {\n        border-left: 3px solid var(--color-tri);\n        border-right: 3px solid var(--color-tri);\n        -webkit-transform: scale(0, 1);\n        transform: scale(0, 1);\n    }\n\n    button:after {\n        border-bottom: 3px solid var(--color-tri);\n        border-top: 3px solid var(--color-tri);\n        -webkit-transform: scale(1, 0);\n        transform: scale(1, 0);\n    }\n\n    button:hover:after,\n    button:hover:before {\n        opacity: 1;\n        -webkit-transform: scale(1);\n        transform: scale(1);\n        border-radius: var(--radius-pri);\n    }\n\n    input {\n        font-weight: var(--weight-tri);\n        color: inherit;\n        width: min(30ch, 90%);\n        height: calc(2 * var(--size-pri));\n        border-radius: calc(0.5 * var(--radius-pri));\n        padding-left: 0.2em;\n    }\n\n    input:focus {\n        outline: 4px solid var(--color-qua);\n        border: none;\n    }\n}\n\n.category-card,\n.initial-main {\n    position: relative;\n    width: 80%;\n    margin-bottom: calc(2 * var(--size-pri));\n    box-shadow: 0.1em 0.6em 0.6em -0.6em var(--color-tri);\n    transition: box-shadow 0.5s ease-in-out;\n    border-radius: var(--size-pri) var(--size-pri) 0 0;\n}\n\n.category-card:hover {\n    box-shadow:\n        0.3em 0.6em 0.6em -0.6em var(--color-tri),\n        -0.3em -0.3em 0.6em -0.6em var(--color-tri);\n}\n\n.category-card-checked {\n    box-shadow: 0.1em 0.6em 0.6em -0.6em var(--color-valid1);\n}\n\n.category-card-checked:hover {\n    box-shadow:\n        0.3em 0.6em 0.6em -0.6em var(--color-valid1),\n        -0.3em -0.3em 0.6em -0.6em var(--color-valid1);\n}\n\ndetails {\n    padding: 0 var(--size-pri);\n    color: var(--color-tri);\n    border-radius: var(--radius-pri);\n    overflow: hidden;\n    position: relative;\n\n    > * {\n        padding-left: var(--size-pri);\n        margin: calc(0.5 * var(--size-pri));\n    }\n\n    summary {\n        font-size: calc(1.5 * var(--size-pri));\n        font-weight: var(--weight-sec);\n    }\n\n    summary:hover {\n        cursor: pointer;\n    }\n\n    summary:first-of-type {\n        list-style-type: none;\n    }\n\n    p {\n        padding-block: 1rem;\n        text-align: justify;\n        text-wrap: pretty;\n        max-width: 70ch;\n        white-space: pre-line;\n    }\n\n    p input {\n        text-align: center;\n        position: relative;\n        inset: 0.1em 1em;\n        margin-right: 2em;\n        width: 1em;\n        aspect-ratio: 1 / 1;\n        appearance: none;\n        border-radius: 10%;\n        border: 1px solid var(--color-invalid1);\n        box-shadow: none;\n        font-size: 1em;\n    }\n\n    p input:checked {\n        background-color: #679464;\n        border: none;\n\n        + label {\n            filter: blur(0.1em);\n            color: var(--color-valid2);\n        }\n    }\n\n    .list-display {\n        display: grid;\n        grid-template-columns: 1fr 10fr;\n        grid-auto-rows: fit-content;\n        gap: calc(0.8 * var(--size-pri));\n    }\n\n    .date {\n        position: absolute;\n        top: 0;\n        right: 0;\n        border-radius: var(--radius-pri);\n        background-color: var(--color-pri);\n        font-size: 0.7em;\n        padding: 0.2em;\n        z-index: 10;\n    }\n}\n\ndetails::details-content {\n    font-size: 1rem;\n    block-size: 0;\n    transition:\n        block-size 1s,\n        content-visibility 1s;\n    transition-behavior: allow-discrete;\n}\n\ndetails:open::details-content {\n    block-size: auto;\n}\n\n.category-interactions {\n    text-align: right;\n    margin-bottom: 0;\n    display: flex;\n    justify-content: right;\n}\n\n.category-interactions button {\n    padding: 0.5em 1em;\n    margin-left: var(--size-pri);\n    border-radius: var(--size-pri) var(--size-pri) 0 0;\n    background-color: var(--color-pri);\n    font-weight: var(--weight-sec);\n    display: flex;\n    justify-content: center;\n}\n\n#edit-btn img {\n    filter: var(--filter-color-valid1);\n}\n\n#edit-btn:hover {\n    background-color: var(--color-valid2);\n\n    img {\n        filter: var(--filter-color-pri);\n    }\n}\n\n#delete-btn img {\n    filter: var(--filter-color-invalid1);\n}\n\n#delete-btn:hover {\n    background-color: var(--color-invalid2);\n\n    img {\n        filter: var(--filter-color-pri);\n    }\n}\n\n@font-face {\n    font-family: \"Akaya\";\n    src:\n        url(\"/src/fonts/AkayaTelivigala-Regular.woff2\") format(\"woff2\"),\n        url(\"/src/fonts/AkayaTelivigala-Regular.woff\") format(\"woff\");\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@keyframes fadeIn {\n    0% {\n        transition:\n            block-size 1s,\n            content-visibility 1s;\n        transition-behavior: allow-discrete;\n        opacity: 0;\n        block-size: 0;\n        content-visibility: hidden;\n    }\n\n    100% {\n        opacity: 1;\n        block-size: auto;\n        content-visibility: visible;\n    }\n}\n\n@media (max-width: 1200px) {\n    .container {\n        width: 100%;\n    }\n}\n\n@media (max-width: 800px) {\n    /* .user-header {\n        padding: auto 1em;\n        margin: auto;\n    } */\n\n    header {\n        gap: var(--size-pri);\n    }\n\n    .user-header img {\n        min-height: 5vh;\n        max-width: 5vh;\n        min-width: 5vh;\n        aspect-ratio: 1 / 1;\n    }\n\n    .user-header,\n    nav {\n        button {\n            display: none;\n        }\n    }\n\n    .menu-header {\n        gap: var(--size-pri);\n        padding: var(--size-pri) 0 var(--size-pri) var(--size-pri);\n        margin-left: 0;\n        justify-content: left;\n\n        span {\n            display: none;\n        }\n\n        img {\n            display: block;\n        }\n    }\n\n    .timer-content,\n    .nav-content,\n    .timer-menu {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .user-header,\n    .timer-menu,\n    .project-content,\n    .category-content,\n    .subcategory-content {\n        min-width: 20vw;\n        grid-template-columns: 1fr;\n        justify-items: center;\n        justify-content: center;\n        justify-self: center;\n\n        > * {\n            margin: auto;\n        }\n    }\n\n    main {\n        padding: calc(2 * var(--size-pri)) calc(0.5 * var(--size-pri));\n    }\n\n    .category-card {\n        width: 100%;\n    }\n\n    details {\n        .list-display {\n            padding-left: 0;\n            padding-right: 0;\n        }\n\n        summary {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: calc(0.5 * var(--size-pri));\n        }\n\n        .date {\n            position: relative;\n        }\n    }\n\n    .category-interactions {\n        justify-content: left;\n        padding: 0;\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
